export default __webpack_public_path__ + "static/media/gnl8.51f88abb.webp";